import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { PhoneInput } from '@/components/inputs';
import { addPrefixToDataParams } from '@/utils/string';
import { Button } from '@/components/buttons';
import { required, phone, pipeValidators } from '@/utils/validators';
import { useMyContractSupportRequestCreateQuery } from '@/api/skippay/myContractSupportRequestCreate';
import { mergeClasses } from '@/utils/style';
import { logEvent } from '@/analytics/events';
const FIELD_PHONE = 'phoneNumber';
interface CallMeFormProps {
  type: 'REVOLVING_LOAN_CALL_ME' | 'REVOLVING_LOAN_CANCELLATION_REQUEST' | 'REVOLVING_LOAN_INCREASE_LIMIT';
  description?: string;
  phoneNumber?: string;
  hideRetentionButton?: boolean;
  id?: string;
  className?: string;
  onCancel?: () => void;
  infoText?: ReactNode;
  phoneLabelWithoutStar?: boolean;
}
export function CallMeForm(t0) {
  const $ = _c(20);
  const {
    className,
    type,
    description,
    phoneNumber,
    hideRetentionButton,
    id,
    onCancel,
    infoText,
    phoneLabelWithoutStar
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["personalDataRequests", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const myContractSupportRequestCreateQuery = useMyContractSupportRequestCreateQuery();
  let t2;
  if ($[1] !== description || $[2] !== myContractSupportRequestCreateQuery || $[3] !== type) {
    t2 = async formData => {
      logEvent("generate_lead", {
        action: "callMe"
      });
      await myContractSupportRequestCreateQuery.mutate({
        ...formData,
        type,
        description
      });
    };
    $[1] = description;
    $[2] = myContractSupportRequestCreateQuery;
    $[3] = type;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== className || $[6] !== hideRetentionButton || $[7] !== id || $[8] !== infoText || $[9] !== myContractSupportRequestCreateQuery.isError || $[10] !== myContractSupportRequestCreateQuery.isPending || $[11] !== myContractSupportRequestCreateQuery.isSuccess || $[12] !== onCancel || $[13] !== phoneLabelWithoutStar || $[14] !== phoneNumber || $[15] !== t) {
    t3 = t4 => {
      const {
        handleSubmit
      } = t4;
      if (myContractSupportRequestCreateQuery.isSuccess) {
        return <p className="font-semibold">{t("personalDataRequests:leaveModal.success")}</p>;
      }
      return <form method="post" onSubmit={handleSubmit} {...addPrefixToDataParams({
        analyticsParam: "callMeForm",
        testId: "callMeForm",
        prefix: "form"
      })} className="w-full">{myContractSupportRequestCreateQuery.isError && <p className="mb-8 font-semibold">{t("personalDataRequests:leaveModal.error")}</p>}<div className={mergeClasses("flex flex-col gap-2 md:gap-4", className)}><div className="w-full flex-1"><Field name={FIELD_PHONE} type="tel" validate={pipeValidators(required, phone)} initialValue={phoneNumber || ""}>{fieldRenderProps => <PhoneInput {...fieldRenderProps} label={phoneLabelWithoutStar ? t("core:forms.fields.phone.optional") : t("core:forms.fields.phone")} {...id && {
                id: `${id}tel`
              }} />}</Field></div>{infoText && <div className="mb-4">{infoText}</div>}<div className="flex min-w-52 shrink-0 flex-col items-center justify-center gap-2 md:flex-row"><Button type="submit" analyticsParam="submitForm" testId="submitForm" variant="primary" align="center" className="m-0! w-full! md:order-1" busy={myContractSupportRequestCreateQuery.isPending}>{t("personalDataRequests:leaveModal.cta")}</Button>{!hideRetentionButton && onCancel && <Button analyticsParam="retention" testId="retention" variant="secondary" className="m-0! w-full! md:order-0" onClick={onCancel}>{t("personalDataRequests:leaveModal.retention")}</Button>}</div></div></form>;
    };
    $[5] = className;
    $[6] = hideRetentionButton;
    $[7] = id;
    $[8] = infoText;
    $[9] = myContractSupportRequestCreateQuery.isError;
    $[10] = myContractSupportRequestCreateQuery.isPending;
    $[11] = myContractSupportRequestCreateQuery.isSuccess;
    $[12] = onCancel;
    $[13] = phoneLabelWithoutStar;
    $[14] = phoneNumber;
    $[15] = t;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t2 || $[18] !== t3) {
    t4 = <Form onSubmit={t2}>{t3}</Form>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}